import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const TranparentButton = styled(Button)((props) => {
  const { disabled } = props;
  return {
    color: "#4177FF",
    backgroundColor: disabled
      ? "rgba(65, 119, 255, 0.1)"
      : "rgba(65, 119, 255, 0.1)",
    borderRadius: "8px",
    textTransform: "lowercase",
    padding: "6px 36px",
    // "&:hover": {
    //   backgroundColor: blue[600],
    // },
  };
});
